// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NTXWQlPRdNiSm1rrf1hd{display:flex;flex-direction:column;gap:1rem}.NTXWQlPRdNiSm1rrf1hd .leVH6Vhgk3xn9qKCpF6D{display:flex;flex-direction:row;flex-wrap:wrap;gap:1rem}.NTXWQlPRdNiSm1rrf1hd .leVH6Vhgk3xn9qKCpF6D .jvH_tmDWhe4kOJwWu2UD{flex:1 1 30%;max-width:30%;min-width:200px;display:flex;gap:1em;flex-direction:row;cursor:pointer}.NTXWQlPRdNiSm1rrf1hd .leVH6Vhgk3xn9qKCpF6D .jvH_tmDWhe4kOJwWu2UD .bKinMTFiWBWXlafHUw3Q{flex:0 0 100px;width:100px}.NTXWQlPRdNiSm1rrf1hd .leVH6Vhgk3xn9qKCpF6D .jvH_tmDWhe4kOJwWu2UD .bKinMTFiWBWXlafHUw3Q .gRP7QM5dF0vrrQgn3_nw{position:relative;height:auto}.NTXWQlPRdNiSm1rrf1hd .leVH6Vhgk3xn9qKCpF6D .jvH_tmDWhe4kOJwWu2UD .bKinMTFiWBWXlafHUw3Q img{width:inherit;border-radius:50%;height:auto;aspect-ratio:1/1;object-fit:cover;max-width:100%}.NTXWQlPRdNiSm1rrf1hd .leVH6Vhgk3xn9qKCpF6D .jvH_tmDWhe4kOJwWu2UD .P92p3ciF8n5mqFc3fqaa{flex:1 1 70%}.NTXWQlPRdNiSm1rrf1hd .leVH6Vhgk3xn9qKCpF6D .yk6lLcYU9NgO2JAsWV9g{position:absolute;border-radius:50%;width:30px;height:30px;padding:5px;font-size:18px;line-height:1;color:#6e32f0;border:1px solid #6e32f0;background-color:#fff;left:50%;margin-left:-15px;bottom:-7px}.NTXWQlPRdNiSm1rrf1hd .ykv5ZRoNUI47ppEV_Smd .gRP7QM5dF0vrrQgn3_nw img{width:inherit;border-radius:50%;height:auto;aspect-ratio:1/1;object-fit:cover;max-width:100%;max-height:150px}.NTXWQlPRdNiSm1rrf1hd .ykv5ZRoNUI47ppEV_Smd .mY6AaU6Q_MWyuhyqmR7c{margin-top:1em}.NTXWQlPRdNiSm1rrf1hd .ykv5ZRoNUI47ppEV_Smd .yk6lLcYU9NgO2JAsWV9g{border-radius:50%;width:30px;height:30px;padding:5px;font-size:18px;line-height:1;color:#6e32f0;border:1px solid #6e32f0;background-color:#fff;left:50%;margin-left:-15px;bottom:-7px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `NTXWQlPRdNiSm1rrf1hd`,
	"listWrapper": `leVH6Vhgk3xn9qKCpF6D`,
	"cell": `jvH_tmDWhe4kOJwWu2UD`,
	"avatarWrapper": `bKinMTFiWBWXlafHUw3Q`,
	"avatarInnerWrapper": `gRP7QM5dF0vrrQgn3_nw`,
	"personInforWrapper": `P92p3ciF8n5mqFc3fqaa`,
	"avatarArrow": `yk6lLcYU9NgO2JAsWV9g`,
	"singlePersonWrapper": `ykv5ZRoNUI47ppEV_Smd`,
	"personBio": `mY6AaU6Q_MWyuhyqmR7c`
};
export default ___CSS_LOADER_EXPORT___;
